import { render, staticRenderFns } from "./FormatPageBackgroundImageEditTool.vue?vue&type=template&id=922360ce&scoped=true&"
import script from "./FormatPageBackgroundImageEditTool.vue?vue&type=script&lang=ts&"
export * from "./FormatPageBackgroundImageEditTool.vue?vue&type=script&lang=ts&"
import style0 from "./FormatPageBackgroundImageEditTool.vue?vue&type=style&index=0&id=922360ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922360ce",
  null
  
)

export default component.exports